import { configureStore } from '@reduxjs/toolkit'
import LoadingStore from './actionReducers/LoadingStore'
import MenuStore from './actionReducers/MenuStore'
import StocksAnalysisStore from './actionReducers/StocksAnalysisStore'
import TrendStore from './actionReducers/TrendStore'
import CommnonStore from './actionReducers/CommnonStore'
import ModalCommonStore from './actionReducers/ModalCommonStore'
import InvestmentPortfolioStore from './actionReducers/InvestmentPortfolioStore'
import OrgStore from './actionReducers/OrgStore'
import NewsStore from './actionReducers/NewsStore'
import ChartStore from './actionReducers/ChartStore'
import MarketStore from './actionReducers/MarketStore'
import CompanyStore from './actionReducers/CompanyStore'
import AnalysisStore from './actionReducers/AnalysisStore'
import ReportStore from './actionReducers/ReportStore'
import AStore from './actionReducers/AStore'
import MomentumStore from './actionReducers/MomentumStore'
import StockInvestStore from './actionReducers/StockInvestStore'
import GrowthStore from './actionReducers/GrowthStore'
import PortfolioStore from './actionReducers/PortfolioStore'

export default configureStore({
  reducer: {
    LoadingStore,
    MenuStore,
    StocksAnalysisStore,
    TrendStore,
    CommnonStore,
    ModalCommonStore,
    InvestmentPortfolioStore,
    OrgStore,
    NewsStore,
    ChartStore,
    MarketStore,
    CompanyStore,
    AnalysisStore,
    ReportStore,
    AStore,
    MomentumStore,
    StockInvestStore,
    GrowthStore,
    PortfolioStore,
  }
})